import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequestWithRetry } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getDomainWithSource } from '@atlassian/jira-software-auto-enable-des/src/services/index.tsx';

const ELIGIBILITY_CHECK_URL = '/gateway/api/invitations/v1/access-settings/org';

type DesSettingsResult = {
	isDesEnabled: boolean;
	domain: string;
};

type AccessSettingsResponse = {
	domain: string;
	adminNotifications: string;
	products: Array<{
		productARI: string;
		adminApprovalRequired: boolean;
		role: string;
	}>;
	enabled: boolean;
};

const noValidDesResult: DesSettingsResult = {
	isDesEnabled: false,
	domain: '',
};

export const checkIsDesEnabled = async (orgId?: string): Promise<DesSettingsResult> => {
	if (!orgId) {
		// early exit if we don't have orgId
		return noValidDesResult;
	}

	const domain = await getDomainWithSource('shareDesLink');

	if (!domain) {
		// early exit if we don't have domain
		return noValidDesResult;
	}

	try {
		const response = await performGetRequestWithRetry<AccessSettingsResponse>(
			`${ELIGIBILITY_CHECK_URL}/${orgId}/domains/${domain}`,
		);

		// 'jira-software' includes JSW and JWM
		const jiraProduct = response.products.find((product) =>
			product.productARI.includes('jira-software'),
		);

		const isDesEnabled = jiraProduct ? !jiraProduct.adminApprovalRequired : false;

		return {
			isDesEnabled,
			domain,
		};
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'checkDesSettings',
				packageName: 'jiraDesShareLink',
				teamName: 'jlove-makkuro',
			},
			error:
				error instanceof Error
					? error
					: new Error(
							'DES check (/gateway/api/invitations/v1/access-settings/org/ORGID/domains/DOMAIN.COM) failed',
						),
		});

		return {
			isDesEnabled: false,
			domain,
		};
	}
};
